import { render, staticRenderFns } from "./view.vue?vue&type=template&id=cb35cfc0"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb35cfc0')) {
      api.createRecord('cb35cfc0', component.options)
    } else {
      api.reload('cb35cfc0', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=cb35cfc0", function () {
      api.rerender('cb35cfc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/transfer/logic/view.vue"
export default component.exports